import { observer } from "mobx-react";
import React, { Component } from "react";
import { InjectedIntl, injectIntl, IntlProvider } from "react-intl";
import leftArrow from "../../../assets/images/left-arrow.svg";
import { StateLink } from "../../../stores/EntityStores/StateStore";
import { MainStore } from "../../../stores/MainStore";
import Image from "../../Image";
import Label from "../../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  intl: IntlProvider & InjectedIntl;
}

interface IState {}

@observer
class DetailsApplyForJob extends Component<IProps, IState> {
  getFormattedMessage(id: string) {
    const { intl } = this.props;
    return intl.formatMessage({ id });
  }
  render() {
    const { store } = this.props;
    const { selectedState } = store;
    if (!selectedState) return null;

    const getLinks = () => {
      if (!selectedState.links) return null;
      return selectedState.links.map((link: StateLink) => {
        return (
          <div className={classes.LinkContainer} key={Math.random()}>
            <div className={classes.Link}>
              <div className={classes.LinkHeader}>
                <a
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={link.link === "#" ? classes.inactiveLink : ""}
                >
                  <Label big bold text={link.title} left />
                </a>
                {link.link === "#" ? null : (
                  <a
                    href={link.link}
                    className={classes.Arrow}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image src={leftArrow} alt={link.title} small />
                  </a>
                )}
              </div>
              <div className={classes.LinkBody}>
                <Label left small text={link.description} />
              </div>
            </div>
          </div>
        );
      });
    };
    return (
      <div className={classes.DetailsApplyForJob}>
        <div className={classes.InlineTitle}>
          <Label
            big
            bold
            text={`${this.getFormattedMessage("details.applyforjob")}`}
          />
        </div>
        {getLinks()}
      </div>
    );
  }
}
export default injectIntl(DetailsApplyForJob);
